<template>
    <div>
        <v-row class="white pl-3 pr-3 ml-0 mr-0">
            <v-col cols="2">
                <az-text-view
                    label="Comissão Responsável"
                    :text="reavaliacao.comissao | textoSemValorSimples"/>
            </v-col>
            <v-col cols="2">
                <az-text-view-edit
                    v-model="reavaliacao.observacao"
                    name="Observações"
                    label="Observações"
                    :validate="'max:500'"
                    maxlength="500"
                    :counter="500"
                    :disabled="!verificaPermissaoEdicao"
                    placeholder="Informe as observações"
                    @keydown.enter="tratarEventoSalvar"
                    @input="tratarEventoSalvar"/>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import AzHasPermissions from '@azinformatica/loki/src/utils/AzHasPermissions'
    import AzTextViewEdit from '@/views/components/AzTextViewEdit.vue'

    export default {
        name: 'ReavaliacaoDetalheCampos',
        components: {AzTextViewEdit},
        props: ['reavaliacao', 'patrimonio'],
        computed: {
            verificaPermissaoEdicao() {
                return AzHasPermissions(this.$store.state.loki.user.authorities, ['Patrimonio.Normal'])
            }
        },
        methods: {
            tratarEventoSalvar() {
                this.$emit('atualizar', this.reavaliacao)
            }
        }
    }
</script>
